`
<template>
    <div class="mobile-detail" style="background-color: #1b55bb;">
        <el-container>
            <el-header>
                <h3 style="color: #FFF"> 河北省计量资源共享服务平台 </h3>
            </el-header>
            <el-main>
                <el-card class="main-card block-white">
                    <h3 align="center"> {{onwerInfo.name}}</h3>
                    <el-form :model="onwerInfo" ref="form" label-width="100px">
                        <el-form-item label="【单位代码】">
                            {{onwerInfo.code}}
                        </el-form-item>
                        <el-form-item label="【联系人】">
                            {{onwerInfo.userName}}
                        </el-form-item>
                        <el-form-item label="【联系电话】">
                            {{onwerInfo.userMobile}}
                        </el-form-item>
                        <el-form-item label="【通讯地址】">
                            {{onwerInfo.postalAddress}}
                            <el-button size="mini" type="primary" @click="openLocation" plain>到这里</el-button>
                        </el-form-item>
                    </el-form>
                </el-card>

                <el-card class="main-card block-white" style="margin: 15px 0;">
                    <h4> 授权证书项目 ({{item.totalCount}})</h4>
                    <div>
                        <el-row class="infinite-list-header">
                            <el-col :span="12">
                                名称
                            </el-col>
                            <el-col :span="12">
                                类型
                            </el-col>
                        </el-row>
                        <div class="infinite-list" style="overflow:auto">
                            <div class="list" v-infinite-scroll="loadMeasuringItems">
                                <el-row v-for="(l, index) in item.list" class="infinite-list-item" :key="'item_' + index">
                                    <el-col :span="12">
                                        <span v-html="l.name"></span>
                                    </el-col>
                                    <el-col :span="12">
                                        {{l.certType | toAuthCertType}}
                                    </el-col>
                                </el-row>
                            </div>
                            <p v-if="item.loading">加载中...</p>
                            <p v-if="item.noMore">没有更多了</p>
                        </div>
                    </div>
                </el-card>

                <el-card class="main-card block-white" style="margin: 15px 0;">
                    <h4> 社会公用计量标准({{standard.totalCount}}) </h4>
                    <div>
                        <el-row class="infinite-list-header">
                            <el-col :span="12">
                                证书号
                            </el-col>
                            <el-col :span="12">
                                名称
                            </el-col>
                        </el-row>
                        <div class="infinite-list" style="overflow:auto">
                            <div class="list" v-infinite-scroll="loadStandardPublic">
                                <el-row v-for="l in standard.list" :key="l.id" class="infinite-list-item">
                                    <el-col :span="12">
                                        {{l.certificateNo}}
                                    </el-col>
                                    <el-col :span="12">
                                        <span v-html="l.name"> </span>
                                    </el-col>
                                </el-row>
                            </div>
                            <p v-if="standard.loading">加载中...</p>
                            <p v-if="standard.noMore">没有更多了</p>
                        </div>
                    </div>
                </el-card>

            </el-main>
        </el-container>
    </div>
</template>

<script>
    import wx from "weixin-js-sdk";
    import {mechanismApi, dictApi, authorizeCertApi} from "@/api/organization";
    import {standardPublicApi} from "@/api/standard";

    export default {
        data() {
            return {
                ownerId: '',
                onwerInfo: {},
                item: {
                    current: 1,
                    size: 10,
                    totalPage: 0,
                    totalCount: 0,
                    list: [],
                    loading: true,
                    noMore: false,
                },
                standard: {
                    current: 1,
                    size: 10,
                    totalPage: 0,
                    totalCount: 0,
                    list: [],
                    loading: true,
                    noMore: false,
                },


            }
        },
        created() {
            this.ownerId = this.$route.params.id;
            this.getDetail();
            this.initWxConfig();
            this.listMeasuringItems();
            this.listStandardPublic();
        },
        methods: {
            loadMeasuringItems() {
                if (this.item.totalPage > this.item.current) {
                    this.item.current++;
                    this.listMeasuringItems();
                } else {
                    this.item.noMore = true;
                }
            },
            loadStandardPublic() {
                if (this.standard.totalPage > this.standard.current) {
                    this.standard.current++;
                    this.listStandardPublic();
                } else {
                    this.standard.noMore = true;
                }
            },
            listStandardPublic() {
                this.standard.loading = true;
                standardPublicApi.mapPage({
                    orgId: this.ownerId,
                    current: this.standard.current,
                    size: this.standard.size,
                    mode: 0,
                    status: 2
                }).then((r) => {
                    if (r.data.result === 0) {
                        this.standard.totalPage = r.data.data.pages;
                        this.standard.totalCount = r.data.data.total;
                        this.standard.list = this.standard.list.concat(r.data.data.records);
                    }
                    this.standard.loading = false;
                });
            },
            listMeasuringItems() {
                this.item.loading = true;
                authorizeCertApi.listItemV2({
                    orgId: this.ownerId,
                    status: 2,
                    current: this.item.current,
                    size: this.item.size
                }).then((r) => {
                    if (r.data.result === 0) {
                        this.item.totalPage = r.data.data.pages;
                        this.item.totalCount = r.data.data.total;
                        this.item.list = this.item.list.concat(r.data.data.records);
                    }
                    this.item.loading = false;
                });
            },
            getDetail() {
                mechanismApi.listMechanismV2({organizationId: this.ownerId}).then((r) => {
                    if (r.data.result === 0) {
                        this.onwerInfo = r.data.data[0];
                    }
                });
            },
            initWxConfig() {
                dictApi.getWxConfig(location.href.split('#')[0]).then(res => {
                    if (res.data.result == 0) {
                        this.openWeiXinConfig(res.data.data, ['openLocation', 'getLocation']);
                    }
                });
            },
            openWeiXinConfig(data, jsApiList) {
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    // appId: "wx33c2b97fed6ed8c5", // 必填，公众号的唯一标识
                    appId: "wxfc1464621ee4a57b",
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.noncestr, // 必填，生成签名的随机串
                    signature: data.signature, // 必填，签名
                    jsApiList: jsApiList,
                });
                wx.ready(function () {
                    console.log("ready");
                });
                wx.error(function (res) {
                    console.log('error---：', res);
                });
            },
            openLocation() {
                const location = this.onwerInfo.location;
                const postalAddress = this.onwerInfo.postalAddress;
                const arr = location.split(',');
                wx.openLocation({
                    latitude: arr[1], // 纬度，浮点数，范围为90 ~ -90
                    longitude: arr[0], // 经度，浮点数，范围为180 ~ -180。
                    name: postalAddress, // 位置名
                    address: postalAddress, // 地址详情说明
                    scale: 10, // 地图缩放级别,整型值,范围从1~28。默认为最大
                    infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
                });
            }
        }
    }
</script>
<style lang="scss">
    .mobile-detail {
        background-image: url(../../../static/image/indexbg.jpg);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top center;
        font-size: 16px !important;
        .el-card__body{
            padding-top: 0px;
        }
        .block-white{
            background: #FFF;
        }
        .el-form-item {
            margin-bottom: 8px;
        }

        .infinite-list-header{
            font-weight: 600;
            display: flex;
            height: 40px;
            color: #2b2828;
            padding: 0;
            margin: 0;
            list-style: none;
            text-align: center;
        }

        .infinite-list {
            height: 300px;
            padding: 0;
            margin: 0;
            list-style: none;
            text-align: center;

            .infinite-list-item {
                font-weight: 600;
                font-size: 14px;
                display: flex;
                color: #000;
                padding-top: 5px;
                padding-bottom: 5px;
            }
        }
    }
</style>`
